<ion-card>
  <ion-card-header>
    <ion-card-title>{{
      !embassadorCase ? 'Identifícate o crea tu cuenta' : '¡Eh, quieto ahí, que no te conozco!'
    }}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <p>
      {{
        !embassadorCase
          ? 'Incia sesión o crea tu cuenta para consultar el estado y seguimiento de tus pedidos, compartirlos o guardarlos' +
            'para realizarlos más tarde, ver el saldo de tu bono o formar parte de nuestros embajadores Copyfly.'
          : 'Identifícate o regístrate y forma parte de nuestra familia embajadora. Podrás obtener dineritos a través de:'
      }}
    </p>
    <ng-container *ngIf="embassadorCase">
      <ul>
        <li>Una URL personalizada para tu cuenta</li>
        <li>Compartir el carrito con tus compañeros o seguidores</li>
        <li>Un cupón personalizado para tus redes sociales.</li>
      </ul>

      <strong><p class="text-center">¿A qué esperas?</p></strong>
    </ng-container>
    <ion-row class="login-button ion-justify-content-center">
      <ion-button type="button" color="google" (click)="doGoogleLogin()">
        <ion-icon name="logo-google"></ion-icon>
        <span>Google</span>
      </ion-button>

      <ion-button color="facebook" (click)="doFacebookLogin()">
        <ion-icon name="logo-facebook"></ion-icon>
        <span>Facebook</span>
      </ion-button>

      <ion-button color="form" (click)="doFormLogin()">
        <ion-icon name="mail"></ion-icon>
        <span>Email</span>
      </ion-button>
    </ion-row>
    <p></p>
  </ion-card-content>
</ion-card>
